module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text2_jp.6323aa77cf8398329b8bce99a3e8190f.png";